import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'mzic-button',
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './mzic-button.component.html',
  styleUrls: ['./mzic-button.component.scss'],
})
export class MzicButtonComponent {
  @Input() id!: string;
  @Input() ariaLabel!: string;
  @Input() ariaLabelledby!: string;
  @Input() ariaDescribedby!: string;
  @Input() ariaDisabled!: string;
  @Input() role!: string;
  @Input() disabled!: boolean;
  @Input() loading!: boolean;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
}
